<script>
import { mapActions } from "vuex";
import SendSvg from "@/assets/img/icon/SendSvg.vue";
export default {
    name: "PublicarMuro",
    components: { SendSvg },
    data() {
        return {
            imagen_muro: "",
            imagen_formato: "",
            texto: "",
            preview: "",
            imagen_perfil_user: this.$ls.get("user").imagen_perfil,
            id_usuario_actual: this.$ls.get("user").id_usuario,
        };
    },
    props: {
        mobile: String,
        color: String,
        userData: Object,
    },
    methods: {
        ...mapActions("home", ["crearNuevoPostMuro"]),
        handleFile() {
            const promise = this.getBase64(this.$refs.file.files[0]);
            const x = this;
            promise.then(function (result) {
                x.imagen_muro = result.split(",")[1];
                x.preview = result;
                if (x.imagen_muro && x.imagen_muro != "") {
                    x.imagen_formato = x.$refs.file.files[0]["type"];
                }
            });
        },
        borrarImg() {
            this.imagen_muro = "";
            this.imagen_formato = "";
            this.preview = "";
        },
        async handleSubmit() {
            let data_ = {
                id_empresa: this.$ls.get("user").id_empresa_fk,
                id_usuario: this.$ls.get("user").id_usuario,
                imagen_muro: this.imagen_muro,
                imagen_formato: this.imagen_formato,
                texto: this.texto,
            };
            //console.log("Se llama el quitarlike", data_);
            await this.crearNuevoPostMuro(data_).then(res => {
                if (res) {
                    //console.log("Resultado de crearComentariosPostMuro: ",res)
                    this.imagen_muro = "";
                    this.imagen_formato = "";
                    this.texto = "";
                    this.preview = "";
                }
                else {
                    console.log("Falla handleSubmit", res);
                }
            });
        },
        //FF
        textareaResize() {
            let textarea = document.querySelector("#textarea-publicar");
            if (this.texto === "") {
                textarea.style.height = "63px";
                return;
            }
            textarea.style.height = "1px";
            textarea.style.height = (25 + textarea.scrollHeight) + "px";
        }
    }
};
</script>

<template>

  <div class="card card-custom border-0">
    <div 
      class="d-flex justify-content-between align-items-center p-3 pb-0 color-main"
    >
      <p class="font-title font-700 mb-0">
        <img src="@/assets/img/intranet/home/icono-muro.svg">
        <span class="ps-2">Muro</span>
      </p>
    </div>
    <div class="card-body">
      <div class="d-flex">
        <div class="flex-shrink-0 avatar-user">
          <img
            width="60"
            height="60"
            v-if="!imagen_perfil_user || !/.jpg|.jpeg|.png/.test(imagen_perfil_user)"
            src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
            class="img-object-cover rounded-circle me-3"
          >
          <img
            v-else
            width="60"
            height="60"
            :src="imagen_perfil_user"
            class="img-object-cover rounded-circle me-3"
          />
        </div>
        <div class="flex-grow-1 ms-3">
          <textarea
              @keyup="textareaResize()"
              id="textarea-publicar"
              class="textarea-auto"
              placeholder="Escribe un comentario ..."
              rows="3"
              v-model="texto"
              maxlength="500"
          ></textarea>
          <div class="form-text text-end text-secondary">
            {{ texto.length }} / 500 caracteres
          </div>
          <div 
            v-if="preview"
            class="d-flex position-relative"
          >
            <a 
              href="javascript:"
              class="btn-remove btn-remove-main position-absolute btn-remove-top-left" 
              @click="borrarImg"
            >
            <font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon> 
            </a>
            <img
              :src="preview"
              class="img-h-300 rounded-4"
              alt="Vista previa de imagen"
            />
          </div>

          <div class="h4 pb-2 mb-2 border-bottom"></div>

          <div class="d-flex justify-content-end align-items-center">
            <div class="flex-grow-1">
              <label
                :for="`file-input${mobile}`"
                class="link-secondary pointer-event"
              >
                <span v-if="preview === '' " key="adjuntar-img">
             
                  <font-awesome-icon icon="fa-solid fa-image" class="pe-1 color-main" ></font-awesome-icon> 
                  
                  Adjuntar imagen
                </span>
                <span v-if="preview !== '' " key="editar-img">
                  <font-awesome-icon icon="fa-solid fa-square-pen" class="pe-1 color-brown" ></font-awesome-icon> 
                  Editar imagen
                </span>           
              </label>

              <input
                :id="`file-input${mobile}`"
                class="d-none"
                type="file"
                accept="image/*"
                ref="file"
                @change="handleFile"
              />
            </div>
            <div class="flex-shrink-0">
              <a 
                @click="handleSubmit"
                href="javascript:"
                class="transition-all color-main"
              >
                <SendSvg/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>